module.exports = __webpack_public_path__ + "static/img/ic-8.56a60db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/ic-8.svg
// module id = T4DD
// module chunks = 1